import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { format } from 'shell-models-lib';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { sapColumnDelimiterMetadata } from '../consts/metadata-consts';

export const sapOpenHubTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sapOpenHub.datasetType,
    displayName: stringResources.SapOpenHub_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.sapOpenHub.linkedServiceType],
    isSource: true,
    isSink: false,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-SapBW'
    },
    tableNameDisplay: stringResources.TableNameDispaly_OpenHubDestination,
    tableNamePlural: stringResources.TableNameDisplay_OpenHubDestinations,
    isFirstClass: true,
    notSupportCopySourceQuery: true,
    isTableNameRequired: true,
    category: ['Database'],
    v2CopySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'excludeLastRequest',
                label: stringResources.ModelName_ExcludeLastRequest
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'baseRequestId',
                label: stringResources.ModelName_BaseRequestId,
                description: stringResources.BaseRequestId_Description
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'customRfcReadTableFunctionModule',
                label: stringResources.ModelName_CustomRfcReadTableFunctionModule,
                description: format(stringResources.CustomRfcReadTableFunctionModule_DescriptionTemplate, stringResources.SapOpenHub_DisplayText)
            },
            dynamicContentTextClass: 'input-spaced'
        },
        sapColumnDelimiterMetadata
    ],
    controls: [
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'excludeLastRequest',
                label: stringResources.ModelName_ExcludeLastRequest
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'baseRequestId',
                label: stringResources.ModelName_BaseRequestId,
                description: stringResources.BaseRequestId_Description
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    v2Controls: [] // required for getDatasetControls function
};
